export default __webpack_public_path__ + "static/media/a011-fsi-10.327ccd43.svg";